import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Sparkles } from "lucide-react";
import { fmtMoney } from "@/lib/api";

export const RateSuggestionCard = ({ rate }) => {
  if (!rate) return null;
  return (
    <Card data-testid="ai-rate-suggestion-card">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <Sparkles className="h-5 w-5 text-[hsl(174,38%,34%)]" />
          AI suggested rate
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex items-end gap-3">
          <span data-testid="ai-rate-suggestion-amount" className="font-display text-4xl">
            {fmtMoney(rate.suggested_total)}
          </span>
          <span className="pb-1 text-sm text-muted-foreground">
            fair range {fmtMoney(rate.min_rate)} – {fmtMoney(rate.max_rate)} {rate.currency}
          </span>
        </div>
        <div className="flex flex-wrap gap-1.5">
          {rate.breakdown?.duration_months && (
            <Badge variant="secondary" className="rounded-full text-[10px]">
              {rate.breakdown.duration_months} month{rate.breakdown.duration_months > 1 ? "s" : ""}
            </Badge>
          )}
          {rate.breakdown?.usage_multiplier && (
            <Badge variant="secondary" className="rounded-full text-[10px]">usage ×{rate.breakdown.usage_multiplier}</Badge>
          )}
          {rate.breakdown?.media_channels_factor && (
            <Badge variant="secondary" className="rounded-full text-[10px]">media reach ×{rate.breakdown.media_channels_factor}</Badge>
          )}
          {rate.breakdown?.company_size_factor && (
            <Badge variant="secondary" className="rounded-full text-[10px]">company factor ×{rate.breakdown.company_size_factor}</Badge>
          )}
          {rate.confidence != null && (
            <Badge variant="secondary" className="rounded-full text-[10px]">{Math.round(rate.confidence * 100)}% confidence</Badge>
          )}
        </div>
        <p className="text-sm text-muted-foreground">{rate.rationale}</p>
      </CardContent>
    </Card>
  );
};
